/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
import Vue from 'vue'
import sharedState from '../shared/state'

export default {
  setLoading,
  setList,
}

function setLoading(state, loading) {
  state.loading = loading
}

function setList(state, { events }) {
  state.list = events
}